import { t } from "@travily/i18n";
import { StandardButton } from "@ui/components/StandardButton";
import { tv } from "@ui/lib/tv";
import heroBannerDesktop from "./assets/hero-banner-desktop.png";
import heroBannerMobile from "./assets/hero-banner-mobile.png";

const heroBanner = tv({
  slots: {
    root: "relative flex h-[340px] w-full items-center justify-center overflow-hidden rounded-3xl shadow-[0px_10px_20px_0px_rgba(49,84,98,0.1)] md:h-[380px] lg:h-[440px]",
    backgroundImage: "pointer-events-none absolute inset-0 size-full rounded-3xl object-cover",
    content: "relative z-10 flex flex-col items-center gap-6 px-5 py-10 text-center md:py-12 lg:py-14",
    heading:
      "bg-gradient-to-b from-[#1e414f] to-[#092632] bg-clip-text text-display-sm font-extrabold leading-[44px] tracking-[-0.36px] text-transparent lg:text-display-lg lg:leading-[72px] lg:tracking-[-0.6px]",
    description:
      "max-w-[612px] text-sm font-normal leading-5 text-[#576366] lg:text-lg lg:leading-6 lg:tracking-[-0.18px]",
    buttons: "flex flex-wrap items-center justify-center gap-2.5",
    insetBorder:
      "pointer-events-none absolute inset-0 rounded-[inherit] shadow-[inset_0px_-1px_0px_0px_rgba(0,0,0,0.15),inset_0px_0px_0px_1px_rgba(0,0,0,0.03)]",
  },
});

export interface HeroBannerProps {
  joinHref: string;
  learnMoreHref: string;
}

export function HeroBanner({ joinHref, learnMoreHref }: HeroBannerProps) {
  const styles = heroBanner();

  return (
    <div className={styles.root()}>
      <img alt="" className={`${styles.backgroundImage()} hidden md:block`} src={heroBannerDesktop} />
      <img alt="" className={`${styles.backgroundImage()} md:hidden`} src={heroBannerMobile} />
      <div className={styles.content()}>
        <div className="flex flex-col items-center gap-3">
          <h1 className={styles.heading()}>{t("components.views.homes.hero_banner.heading")}</h1>
          <p className={styles.description()}>{t("components.views.homes.hero_banner.description")}</p>
        </div>
        <div className={styles.buttons()}>
          <StandardButton className="whitespace-nowrap px-8" color="pink" href={joinHref} size="44">
            {t("components.views.homes.hero_banner.join_cta")}
          </StandardButton>
          <StandardButton className="whitespace-nowrap px-8" color="neutral" href={learnMoreHref} size="44">
            {t("components.views.homes.hero_banner.learn_more_cta")}
          </StandardButton>
        </div>
      </div>
      <div className={styles.insetBorder()} />
    </div>
  );
}
